import { render, staticRenderFns } from "./logisticsCompany.vue?vue&type=template&id=b201c52c&scoped=true&"
import script from "./logisticsCompany.vue?vue&type=script&lang=js&"
export * from "./logisticsCompany.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCompany.vue?vue&type=style&index=0&id=b201c52c&lang=scss&scoped=true&"
import style1 from "./logisticsCompany.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b201c52c",
  null
  
)

export default component.exports